const updates = [
  {
    date: '07-31',
    title: '《星际远征》4K蓝光版正式上线',
    desc: '年度科幻巨制以超清4K HDR画质呈现，带来前所未有的视觉震撼',
    tag: '新片上线',
  },
  {
    date: '07-30',
    title: '平台画质引擎全面升级至第五代',
    desc: '蓝光画质压缩算法优化，同等带宽下清晰度提升40%',
    tag: '技术升级',
  },
  {
    date: '07-29',
    title: '华语经典回顾专题全新上线',
    desc: '精选500+部经典华语影片，全部以4K修复版呈现',
    tag: '专题上线',
  },
  {
    date: '07-28',
    title: '观影流畅度优化工程完成',
    desc: '全球CDN节点扩展至68个，加载速度平均提升55%',
    tag: '体验优化',
  },
  {
    date: '07-27',
    title: '暑期档动作大片合集热映中',
    desc: '《极限营救》系列全部更新至蓝光画质，燃爆整个夏天',
    tag: '热门推荐',
  },
  {
    date: '07-26',
    title: '移动端观影体验全面优化',
    desc: '自适应码率技术上线，根据网络环境智能调整4K画质',
    tag: '功能更新',
  },
  {
    date: '07-25',
    title: '纪录片精选频道内容扩充',
    desc: '新增自然、历史、科技三大板块，全部支持超清画质',
    tag: '内容更新',
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <div className="inline-flex items-center gap-2 bg-primary-100/80 px-4 py-2 rounded-full mb-5">
              <i className="ri-timer-line text-primary-600 text-sm"></i>
              <span className="text-primary-700 text-xs font-medium">实时更新</span>
            </div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
              最新动态
            </h2>
            <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
              关注麻花影院最新内容更新与技术升级，不错过每一部超清大片
            </p>
          </div>

          <div className="relative">
            <div className="absolute left-[19px] top-0 bottom-0 w-px bg-background-300"></div>

            <div className="space-y-6">
              {updates.map((item, i) => (
                <div key={i} className="relative flex gap-5 pl-12">
                  <div className="absolute left-0 top-1 w-[39px] h-[39px] rounded-full border-2 border-background-300 bg-background-50 flex items-center justify-center z-10">
                    <div className="w-2.5 h-2.5 rounded-full bg-primary-500"></div>
                  </div>

                  <div className="flex-1 bg-background-50 border border-background-200/70 rounded-xl p-5 hover:border-primary-200/70 transition-colors duration-200">
                    <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4 mb-2">
                      <span className="text-foreground-400 text-xs font-mono whitespace-nowrap">{item.date}</span>
                      <span className="bg-secondary-100 text-secondary-700 text-[10px] px-2.5 py-0.5 rounded-full w-fit whitespace-nowrap">
                        {item.tag}
                      </span>
                    </div>
                    <h3 className="font-heading text-foreground-900 font-semibold text-sm mb-1.5">
                      {item.title}
                    </h3>
                    <p className="text-foreground-500 text-xs leading-relaxed">{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}